module.exports = __webpack_public_path__ + "static/media/nsu_logo.7dc07a2b.png";